var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThoughtLinkImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1893_2701)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31848 15.67L5.83247 15.1865C5.58441 15.0979 4.57695 14.6676 2.97465 12.9539L1.44828 11.4276C0.876208 10.8555 1.24071 9.87588 2.04313 9.8126C1.81532 9.21015 2.23804 8.56214 2.87846 8.52923C2.76708 8.19004 2.85568 7.81794 3.10881 7.56228C3.27587 7.39522 3.49356 7.30409 3.71631 7.2889C3.51634 6.7143 3.92135 6.02832 4.61239 6.02832C4.86552 6.02832 5.10346 6.12704 5.28318 6.30676L6.36911 7.39269L7.09305 8.11663C7.72588 7.78757 8.57639 7.73694 9.0548 8.2432C9.89013 9.12915 9.68763 9.81513 9.51044 10.4226C9.36615 10.9061 9.24465 11.3263 9.62181 11.868L9.87241 12.1161L6.31848 15.67Z",
    fill: "#D31C4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41696 18.5003C8.21192 18.5003 7.99676 18.4015 7.82463 18.232L6.62733 17.0347C6.36408 16.7714 6.24258 16.336 6.5033 16.0753L10.2572 12.3239C10.5129 12.0657 10.9482 12.1796 11.2166 12.448L12.4139 13.6453C12.6771 13.9085 12.7986 14.3439 12.5379 14.6046L8.78399 18.356C8.69287 18.4496 8.56124 18.5003 8.41696 18.5003Z",
    fill: "#D31C4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97936 16.7234C3.70598 16.7234 3.50601 16.4601 3.57689 16.1969L5.16148 10.2812C5.19944 10.137 5.30576 10.0256 5.4551 9.98761C5.76139 9.91167 6.05249 10.1775 5.96643 10.4989L4.38184 16.412C4.33374 16.5943 4.16921 16.7234 3.97936 16.7234ZM6.30309 8.0537C6.02971 8.0537 5.8272 7.79298 5.89808 7.52972L7.70036 0.809149C7.73833 0.662334 7.84464 0.550957 7.99399 0.512988C8.30027 0.437049 8.59137 0.705366 8.50531 1.02431L6.70556 7.74488C6.65494 7.92714 6.4904 8.0537 6.30309 8.0537Z",
    fill: "#D31C4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.657 8.03861C11.946 8.03861 9.73617 6.32493 7.65039 5.83133L8.90844 1.13325C8.93629 1.02947 8.94388 0.92822 8.93375 0.832031C11.2777 1.36866 13.6571 3.35066 16.5985 2.99375C16.8061 2.96844 16.9174 3.23169 16.7529 3.36332L14.4089 5.24407L15.5835 7.69436C15.6442 7.82345 15.5632 7.9728 15.4214 7.99052C15.1683 8.02089 14.9127 8.03861 14.657 8.03861Z",
    fill: "#D31C4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1893_2701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoughtLinkImg);
export default __webpack_public_path__ + "static/media/ThoughtLinkImg.e88674c91030df2f80a338a62ccc6bea.svg";
export { ForwardRef as ReactComponent };